export enum ViewType {
    /// <summary>
    /// View for member data
    /// </summary>
    Members = 0,

    /// <summary>
    /// View for custom list data
    /// </summary>
    CustomList = 1,

    /// <summary>
    /// View for public site members
    /// </summary>
    PublicSiteMembers = 2
}
